var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  color: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333,
  d: "M2.667 8a5.333 5.333 0 0 0 9.954 2.667M2.666 8a5.333 5.333 0 0 1 9.954-2.667M2.666 8H1.334m9.333 0a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m0 0h4"
})));
export default SvgToolCall;